module.exports = __webpack_public_path__ + "themes/non-default/addeparStep5Sync.670af228244f207cf80566eca7812c0e.png";